import React, { useState, useEffect } from 'react';
import '../styles.css';
import Button from './Button.js';
import ComboDropdown from './ComboDropdown.js';
import ProjectButton from './projectButton.js';
import { useNavigate } from 'react-router-dom';
import { storageAssets } from '../storage_assets';
import { projectRegistry } from '../content/projectRegistry';
import { openExternal } from '../utils/openExternal';
import {
    AboutIcon,
    GitHubIcon,
    LinkedInIcon,
    MailIcon,
    MediumIcon,
    MoreIcon,
    ResumeIcon,
} from '../icons/navigationIcons';
import { SOCIAL_URLS } from '../content/socialLinks';

const ScrollableWindow = () => {
    const navigate = useNavigate();
    const [currentHoverPreview, setCurrentHoverPreview] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const imageStyles = {
        [storageAssets.byuCollage]: { maxWidth: '80%' },
        [storageAssets.multipleChoice]: { maxWidth: '50%', border: '1px solid var(--color-border)' },
        [storageAssets.gameplay]: { maxWidth: '100%' },
        [storageAssets.consoleIterationFinal]: { maxWidth: '100%', border: '1px solid var(--color-border)' },
        [storageAssets.moaTwo]: { maxWidth: '100%' },
        [storageAssets.finalIteration]: { maxWidth: '100%' },
        [storageAssets.breezeFinalDashboard]: {
            maxWidth: '100%',
            border: '1px solid var(--color-border)',
        },
        [storageAssets.askElephantDesktopIntro]: {
            maxWidth: '98%',
            maxHeight: 'min(60vh, 540px)',
            border: '1px solid var(--color-border)',
        },
    };
    const videoStyles = {
        [storageAssets.byuCollage]: { maxWidth: '80%' },
        [storageAssets.multipleChoice]: { maxWidth: '50%', border: '1px solid var(--color-border)' },
    };
    const [videoReady, setVideoReady] = useState(false);
    

    useEffect(() => {
        setVideoReady(false);
    }, [currentHoverPreview]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLinkedInClick = () => {
        openExternal(SOCIAL_URLS.linkedin);
    };

    const handleAboutClick = () => {
        navigate("/about-page");
    };    

    const handleEmailClick = () => {
        window.location.href = 'mailto:aoshumway8@gmail.com';
    };

    const handleResumeClick = () => {
        const link = document.createElement('a');
        link.href = '/resume.pdf';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleGitHubClick = () => {
        openExternal(SOCIAL_URLS.github);
    };

    const handleMediumClick = () => {
        openExternal(SOCIAL_URLS.medium);
    };

    const preview = currentHoverPreview;
    const PreviewComp =
        preview?.type === 'component' ? preview.Component : null;

    return (
        <div className="scrollable-window">
            <div style={styles.wholeThingBox}>
                <div style={styles.allTextBox}>
                    <div className="fade-in-section delay-1" style={styles.headerBox}>
                        <div style={styles.titleBox}>
                            <div className="text-header-main">
                                Adam Shumway
                            </div>
                            <div className="text-body-sm">
                                Technical product designer
                            </div>
                        </div>
                    </div>
                    <div className="fade-in-section-opacity delay-2" style={styles.buttonBoxInner}>
                        <div style={styles.buttonBox}>
                        <div className="tooltip-wrapper">
                            <Button
                                icon={<AboutIcon />}
                                aria-label="About"
                                onClick={handleAboutClick}
                            />
                            <span className="tooltip-text">About</span>
                        </div>
                        <div className="tooltip-wrapper">
                            <Button
                                icon={<ResumeIcon />}
                                aria-label="Resume"
                                onClick={handleResumeClick}
                            />
                            <span className="tooltip-text">Resume</span>
                        </div>
                        <div className="tooltip-wrapper">
                            <Button
                                icon={<LinkedInIcon />}
                                aria-label="LinkedIn"
                                onClick={handleLinkedInClick}
                            />
                            <span className="tooltip-text">LinkedIn</span>
                        </div>
                        </div>
                        <ComboDropdown
                            triggerIcon={<MoreIcon />}
                            aria-label="More links"
                            align="start"

                            items={[
                                {
                                    key: 'github',
                                    label: 'GitHub',
                                    icon: <GitHubIcon />,
                                    onClick: handleGitHubClick,
                                },
                                {
                                    key: 'medium',
                                    label: 'Medium',
                                    icon: <MediumIcon />,
                                    onClick: handleMediumClick,
                                },
                                {
                                    key: 'contact',
                                    label: 'Contact',
                                    icon: <MailIcon />,
                                    onClick: handleEmailClick,
                                },
                            ]}
                        />
                    </div>
                    <div id="portfolio-projects" style={styles.projectBox}>
                        {projectRegistry.map((project) => (
                            <ProjectButton
                                key={project.id}
                                title={project.title}
                                subtitle={project.subtitle}
                                projectPath={project.path}
                                delay={project.delay}
                                hoverPreview={project.hoverPreview}
                                onHoverStart={isMobile ? null : setCurrentHoverPreview}
                                onHoverEnd={isMobile ? null : () => setCurrentHoverPreview(null)}
                            />
                        ))}
                    </div>
                </div>
                <div className="imageBox" style={{ position: 'relative' }}>
                    {currentHoverPreview && currentHoverPreview.type === 'image' && (
                        <img
                            src={currentHoverPreview.src}
                            alt={currentHoverPreview.alt || 'Preview'}
                            style={{
                                position: 'absolute',
                                width: 'auto',
                                borderRadius: '8px',
                                transition: 'opacity 0.4s ease',
                                opacity: 1,
                                pointerEvents: 'none',
                                ...imageStyles[currentHoverPreview.src] || {},
                            }}
                        />
                    )}

                    {currentHoverPreview && currentHoverPreview.type === 'video' && !videoReady && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2,
                    }}>
                        <div className="spinner" />
                    </div>
                    )}

                    {currentHoverPreview && currentHoverPreview.type === 'video' && (
                        <video
                            src={currentHoverPreview.src}
                            autoPlay
                            muted
                            loop
                            playsInline
                            onCanPlay={() => setVideoReady(true)}
                            style={{
                                position: 'absolute',
                                maxWidth: '80%',
                                borderRadius: '8px',
                                transition: 'opacity 0.4s ease',
                                opacity: videoReady ? 1 : 0,
                                pointerEvents: 'none',
                                ...videoStyles[currentHoverPreview.src] || {},
                            }}
                        />
                    )}

                    {PreviewComp && (
                        <>
                            {preview.injectCss ? (
                                <style>{preview.injectCss}</style>
                            ) : null}
                            <div style={styles.hoverComponentWrap}>
                                <PreviewComp
                                    style={preview.componentStyle}
                                    aria-label={preview.alt || 'Preview'}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const styles = {
    wholeThingBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '40px',
        alignSelf: 'stretch',
    },
    allTextBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '32px',
    },
    headerBox: {
        display: 'flex',
        padding: '0px 16px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px'
    },
    titleBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '2px'
    },
    buttonBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        position: 'relative',
        zIndex: 1,
    },
    buttonBoxInner: {
        display: 'flex',
        alignItems: 'center',
        gap: '0px',
        position: 'relative',
        zIndex: 1,
    },
    projectBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '12px',
        position: 'relative',
        zIndex: 0,
    },
    hoverComponentWrap: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
    },
};


export default ScrollableWindow;